import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import noop from 'lodash/fp/noop';
import Checkbox from '../checkbox/Checkbox';
const TreeSelectAll = (props) => {
    const { isDisabled, isChecked = false, isEnabled = true, isIndeterminate = false, hasSearchResults = false, // needed?
    onSelect = noop, } = props;
    const handleSelectAll = (event) => onSelect(event.target.checked, isIndeterminate);
    return isEnabled ? (_jsx("div", Object.assign({ className: 'TreeSelectAll display-flex align-items-center' }, { children: _jsx(Checkbox, { checked: isChecked, onClick: handleSelectAll, disabled: isDisabled, indeterminate: isIndeterminate, className: 'margin-top--1' }) }))) : null;
};
export default TreeSelectAll;
